import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Lenis from "lenis";
import Home from "@/pages/Home";
import EarnWithUs from "@/pages/EarnWithUs";
import CityLanding from "@/pages/CityLanding";
import Owner from "@/pages/Owner";
import Pay from "@/pages/Pay";

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);

    const handleClick = (e) => {
      const anchor = e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!anchor) return;
      const raw = anchor.getAttribute("href");
      const hash = raw.startsWith("/#") ? raw.slice(1) : raw;
      if (hash.length > 1 && hash[0] === "#") {
        const el = document.querySelector(hash);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80 });
        }
      }
    };
    document.addEventListener("click", handleClick);

    return () => {
      cancelAnimationFrame(rafId);
      document.removeEventListener("click", handleClick);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="App grain bg-[#1C1C1C]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/earn-with-us" element={<EarnWithUs />} />
          <Route path="/dallas-fort-worth" element={<CityLanding metro="dallas-fort-worth" />} />
          <Route path="/memphis" element={<CityLanding metro="memphis" />} />
          <Route path="/owner" element={<Owner />} />
          <Route path="/pay/:token" element={<Pay />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
